<script lang="ts">
  import EmployeeList from '../../components/employee/selectEmployer/employeeList.svelte';
</script>

<div class="employee-list-page">
  <EmployeeList />
</div>

<style>
  .employee-list-page {
    min-height: 100vh;
    background-color: #f9fafb;
  }
</style> 